import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { SocketProvider } from "./SocketContext";
import './index.css';
import App from './App';
import config from "./config/config";
import { ThemeProviderWrapper } from './ThemeContext'; // Renaming to avoid confusion

import store, { persistor } from "./store/appStore";

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <ThemeProviderWrapper>
          <SocketProvider>
            <App />
          </SocketProvider>
          {config.QUERY_DEV_TOOLS_ENABLED && <ReactQueryDevtools initialIsOpen={false} />}
        </ThemeProviderWrapper>
      </QueryClientProvider>
    </PersistGate>
  </Provider>
);
